import { FC, useState } from "react";
import { SlArrowUp } from "react-icons/sl";

import styles from "./ArrowTopButton.module.scss";

export const ArrowTopButton: FC = () => {
  const [isHover, setIsHover] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div
      className={styles.arrow}
      onClick={scrollToTop}
      onMouseOver={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      style={{ borderColor: isHover ? "#7bdcb5" : "transparent" }}
    >
      <SlArrowUp size="1.5rem" color={isHover ? "#7bdcb5" : "#a8a5a5"} />
    </div>
  );
};
